import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  return <footer className="bg-gray-100 py-8 mt-auto" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="flex flex-col md:flex-row justify-between mb-6" data-id="element-17">
          <div className="mb-6 md:mb-0" data-id="element-18">
            <h3 className="font-bold text-lg mb-2" data-id="element-19">ClearNail</h3>
            <p className="text-sm text-gray-600 max-w-xs" data-id="element-20">
              Uw betrouwbare partner voor gezondheids- en welzijnsproducten.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8" data-id="element-21">
            <div data-id="element-22">
              <h4 className="font-semibold mb-3" data-id="element-23">Bedrijf</h4>
              <ul className="space-y-2 text-sm" data-id="element-24">
                <li data-id="element-25">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-26">
                    Over Ons
                  </Link>
                </li>
                <li data-id="element-27">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-28">
                    Carrières
                  </Link>
                </li>
                <li data-id="element-29">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-30">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-31">
              <h4 className="font-semibold mb-3" data-id="element-32">Ondersteuning</h4>
              <ul className="space-y-2 text-sm" data-id="element-33">
                <li data-id="element-34">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-35">
                    FAQ
                  </Link>
                </li>
                <li data-id="element-36">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-37">
                    Verzending
                  </Link>
                </li>
                <li data-id="element-38">
                  <Link to="#" className="text-gray-600 hover:text-[#0D9488]" data-id="element-39">
                    Retourneren
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="text-sm text-gray-600 pt-4 border-t border-gray-200" data-id="element-40">
          <p data-id="element-41">© 2023 ClearNail. Alle rechten voorbehouden.</p>
          <div className="flex space-x-4 mt-2" data-id="element-42">
            <Link to="#" className="hover:text-[#0D9488]" data-id="element-43">
              Privacybeleid
            </Link>
            <Link to="#" className="hover:text-[#0D9488]" data-id="element-44">
              Gebruiksvoorwaarden
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};